import SectionComponent from "./section.component";

export default class AppointmentSelectionComponent extends SectionComponent {
 
    #resourcesService;

    get #hierarchyComponent() {
        return this.querySelector("vee24-scheduler-hierarchy-appointments");
    }
    
    get #appointmentTypeComponent() {
        return this.querySelector("vee24-scheduler-appointment-type-section");
    }

    constructor() {
        super();
    }

    init(resourcesService) {
        this.#resourcesService = resourcesService;
    }

    setupAppointmentList(data) {
        this.setContent(`<vee24-scheduler-appointment-type-section></vee24-scheduler-appointment-type-section>`);
        this.#appointmentTypeComponent.init(this.#resourcesService);
        this.#appointmentTypeComponent.setupAppointmentTypeUI(data);
    }

    setupCategories(data, options, resourcesService)  {
        this.setContent(`<vee24-scheduler-hierarchy-appointments></vee24-scheduler-hierarchy-appointments>`);
        
        this.#hierarchyComponent.init(data, resourcesService);
        this.#hierarchyComponent.render(options);
    }
}